import React from 'react';
import {
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@mui/material';
import { HeaderModal, ButtonConsensus } from 'components';
import { colors } from 'utils/colorsSteps';

const ModalConfirm = props => {
  const { open, onClose, group, onClick, onClickNo, sendRequest } = props;

  const handleConfirm = () => {
    onClick(group);
  };

  const handleNo = () => {
    if (onClickNo) {
      onClickNo();
    } else {
      onClose();
    }
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="sm"
      >
        <HeaderModal onClose={onClose}>Criar movimentação</HeaderModal>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Typography variant="h5">
              O responsável da custódia foi informado. Deseja criar a Audiência de Custódia para esse responsável?
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ padding: 15 }}>
          <ButtonConsensus
            title="Não"
            backgroundColor="#fff"
            hovercolor={colors.greySecundary}
            color={colors.greyShadow}
            onClick={handleNo}
          />
          <ButtonConsensus
            title="Criar Movimentação"
            backgroundColor={colors.primary}
            hovercolor={colors.primary}
            onClick={handleConfirm}
            disabled={sendRequest}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ModalConfirm;